import { render } from "./AuthBanner.vue?vue&type=template&id=a201a8ac&scoped=true"
import script from "./AuthBanner.vue?vue&type=script&lang=js"
export * from "./AuthBanner.vue?vue&type=script&lang=js"

import "./AuthBanner.vue?vue&type=style&index=0&id=a201a8ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a201a8ac"]])

export default __exports__